import { render } from "./ListaList.vue?vue&type=template&id=8b52dfc0"
import script from "./ListaList.vue?vue&type=script&lang=js"
export * from "./ListaList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__